import settings from '../../js/utilities/settings'
import cache from '../../js/utilities/cache'

const enable = () => {
  cache.$navSwitch.on('click', (e) => {
    e.preventDefault()

    // Toggle mobile nav
    if (cache.$header.hasClass('is-open')) {
      cache.$header.removeClass('is-open')
    } else if (cache.$body.hasClass('cart-is-open')) {
      cache.$cartSwitch.text('Cart')
      cache.$body.removeClass('cart-is-open')

      setTimeout(() => {
        cache.$header.addClass('is-open')
      }, settings.SPEED / 2)
    } else {
      cache.$header.addClass('is-open')
    }
  })
}

export default { enable }
